export default "__VITE_ASSET__5d06b828__"